// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_or__Ll8Cj::before,
.style_or__Ll8Cj::after {
  display: inline-block;
  content: "";
  border-bottom: 1px solid #535353;
  width: 4rem;
  margin: 4px 8px;
}

.style_patient_section__iZiXz,
.style_doctor_section__YIzCf {
  overflow: hidden;
  height: 225px;
}

.style_patient_section__iZiXz:hover,
.style_doctor_section__YIzCf:hover,
.style_printing3d_section__GIwog:hover {
  border: 1px solid #0d6efd !important;
}

.style_patient_section__iZiXz p {
  font-size: 10px;
}

.style_patient_section__iZiXz button {
  font-size: 10px;
}

.style_patient_date__HOXan {
  margin-top: -14px;
}

.style_file_upload__t3QRG input[type="file"] {
  display: none;
}

textarea {
  resize: none;
}

.style_row_upload_data__HXB\\+b {
  pad: 20px 30px 20px 30px;
}

.style_row_browse_files__rgkbU {
  /* height: 140px; */
}

.style_select_printing__DIWu4:checked+label {
  color: #275ff8 !important;
}

@media only screen and (max-width: 770px) {
  .style_row__p\\+KXv {
    width: 100% !important;
  }

  .style_left_row__TDs5g {
    margin: 0px 4% !important;
  }

  .style_rigth_row__tZzpO {
    margin: 0px 2% !important;
  }
}

.style_header_section__bebgg {
  background: #FFFFFF;
  background: linear-gradient(to top, #FFFFFF, #B3D6EE);
}

 .style_invoice_footer__VIdax {
  background: #FFFFFF;
  background: linear-gradient(to bottom, #FFFFFF, #B3D6EE);
}

@media only screen and (max-width: 383px) {

  .style_patient_section__iZiXz,
  .style_doctor_section__YIzCf,
  .style_printing3d_section__GIwog,
  .style_printing360_section__onTeO {
    width: 90% !important;
  }

  .style_row_browse_files_box__kY6Tf {
    width: fit-content !important;
  }
}

.style_form_checkbox__gpukv {
  appearance: none;
  display: inline-block;
  position: relative;
  background-color: #f1f1f1;
  color: #666;
  top: 10px;
  height: 30px;
  width: 30px;
  border: 0;
  border-radius: 3px;
  cursor: pointer;
  margin-right: 7px;
  outline: none;
  background-image: "";
}

.style_form_checkbox__gpukv:checked::before {
  position: absolute;
  font: 13px/1 "Open Sans", sans-serif;
  left: 11px;
  top: 7px;
  content: "\\02143";
  transform: rotate(40deg);
}

.style_form_checkbox__gpukv:hover {
  background-color: #f7f7f7;
}

.style_form_checkbox__gpukv:checked {
  background-color: #f1f1f1;
}

.style_doctor-form__4dSWl .style_MuiInputLabel-root__GSUKB.style_MuiInputLabel-formControl__RvCxV.style_MuiInputLabel-animated__LYF5\\+.style_MuiInputLabel-sizeSmall__CwBBW.style_MuiInputLabel-outlined__t433q.style_MuiFormLabel-root__Tw5\\+r.style_MuiFormLabel-colorPrimary__HQncB.style_css-1pysi21-MuiFormLabel-root-MuiInputLabel-root__HDXtx {
  font-size: 13px;
}

.style_select_data__f5l3K,
.style_label_data__6\\+Ka9 {
  color: #afafb9;
  height: 100%;
}


.style_select_data__f5l3K:checked+label {
  background: #ddebff !important;
  color: #275ff8 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/requestTracking/requestTrackingPrinting/style.module.css"],"names":[],"mappings":"AAAA;;EAEE,qBAAqB;EACrB,WAAW;EACX,gCAAgC;EAChC,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;EAGnB,qDAAqD;AACvD;;CAEC;EACC,mBAAmB;EAGnB,wDAAwD;AAC1D;;AAEA;;EAEE;;;;IAIE,qBAAqB;EACvB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EAGE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,UAAU;EACV,QAAQ;EACR,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,YAAY;AACd;;;AAGA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B","sourcesContent":[".or::before,\r\n.or::after {\r\n  display: inline-block;\r\n  content: \"\";\r\n  border-bottom: 1px solid #535353;\r\n  width: 4rem;\r\n  margin: 4px 8px;\r\n}\r\n\r\n.patient_section,\r\n.doctor_section {\r\n  overflow: hidden;\r\n  height: 225px;\r\n}\r\n\r\n.patient_section:hover,\r\n.doctor_section:hover,\r\n.printing3d_section:hover {\r\n  border: 1px solid #0d6efd !important;\r\n}\r\n\r\n.patient_section p {\r\n  font-size: 10px;\r\n}\r\n\r\n.patient_section button {\r\n  font-size: 10px;\r\n}\r\n\r\n.patient_date {\r\n  margin-top: -14px;\r\n}\r\n\r\n.file_upload input[type=\"file\"] {\r\n  display: none;\r\n}\r\n\r\ntextarea {\r\n  resize: none;\r\n}\r\n\r\n.row_upload_data {\r\n  pad: 20px 30px 20px 30px;\r\n}\r\n\r\n.row_browse_files {\r\n  /* height: 140px; */\r\n}\r\n\r\n.select_printing:checked+label {\r\n  color: #275ff8 !important;\r\n}\r\n\r\n@media only screen and (max-width: 770px) {\r\n  .row {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .left_row {\r\n    margin: 0px 4% !important;\r\n  }\r\n\r\n  .rigth_row {\r\n    margin: 0px 2% !important;\r\n  }\r\n}\r\n\r\n.header_section {\r\n  background: #FFFFFF;\r\n  background: -webkit-linear-gradient(bottom, #FFFFFF, #B3D6EE);\r\n  background: -moz-linear-gradient(bottom, #FFFFFF, #B3D6EE);\r\n  background: linear-gradient(to top, #FFFFFF, #B3D6EE);\r\n}\r\n\r\n .invoice_footer {\r\n  background: #FFFFFF;  \r\n  background: -webkit-linear-gradient(top, #FFFFFF, #B3D6EE);\r\n  background: -moz-linear-gradient(top, #FFFFFF, #B3D6EE);\r\n  background: linear-gradient(to bottom, #FFFFFF, #B3D6EE);\r\n}\r\n\r\n@media only screen and (max-width: 383px) {\r\n\r\n  .patient_section,\r\n  .doctor_section,\r\n  .printing3d_section,\r\n  .printing360_section {\r\n    width: 90% !important;\r\n  }\r\n\r\n  .row_browse_files_box {\r\n    width: fit-content !important;\r\n  }\r\n}\r\n\r\n.form_checkbox {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  display: inline-block;\r\n  position: relative;\r\n  background-color: #f1f1f1;\r\n  color: #666;\r\n  top: 10px;\r\n  height: 30px;\r\n  width: 30px;\r\n  border: 0;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n  margin-right: 7px;\r\n  outline: none;\r\n  background-image: \"\";\r\n}\r\n\r\n.form_checkbox:checked::before {\r\n  position: absolute;\r\n  font: 13px/1 \"Open Sans\", sans-serif;\r\n  left: 11px;\r\n  top: 7px;\r\n  content: \"\\02143\";\r\n  transform: rotate(40deg);\r\n}\r\n\r\n.form_checkbox:hover {\r\n  background-color: #f7f7f7;\r\n}\r\n\r\n.form_checkbox:checked {\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n.doctor-form .MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-sizeSmall.MuiInputLabel-outlined.MuiFormLabel-root.MuiFormLabel-colorPrimary.css-1pysi21-MuiFormLabel-root-MuiInputLabel-root {\r\n  font-size: 13px;\r\n}\r\n\r\n.select_data,\r\n.label_data {\r\n  color: #afafb9;\r\n  height: 100%;\r\n}\r\n\r\n\r\n.select_data:checked+label {\r\n  background: #ddebff !important;\r\n  color: #275ff8 !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"or": `style_or__Ll8Cj`,
	"patient_section": `style_patient_section__iZiXz`,
	"doctor_section": `style_doctor_section__YIzCf`,
	"printing3d_section": `style_printing3d_section__GIwog`,
	"patient_date": `style_patient_date__HOXan`,
	"file_upload": `style_file_upload__t3QRG`,
	"row_upload_data": `style_row_upload_data__HXB+b`,
	"row_browse_files": `style_row_browse_files__rgkbU`,
	"select_printing": `style_select_printing__DIWu4`,
	"row": `style_row__p+KXv`,
	"left_row": `style_left_row__TDs5g`,
	"rigth_row": `style_rigth_row__tZzpO`,
	"header_section": `style_header_section__bebgg`,
	"invoice_footer": `style_invoice_footer__VIdax`,
	"printing360_section": `style_printing360_section__onTeO`,
	"row_browse_files_box": `style_row_browse_files_box__kY6Tf`,
	"form_checkbox": `style_form_checkbox__gpukv`,
	"doctor-form": `style_doctor-form__4dSWl`,
	"MuiInputLabel-root": `style_MuiInputLabel-root__GSUKB`,
	"MuiInputLabel-formControl": `style_MuiInputLabel-formControl__RvCxV`,
	"MuiInputLabel-animated": `style_MuiInputLabel-animated__LYF5+`,
	"MuiInputLabel-sizeSmall": `style_MuiInputLabel-sizeSmall__CwBBW`,
	"MuiInputLabel-outlined": `style_MuiInputLabel-outlined__t433q`,
	"MuiFormLabel-root": `style_MuiFormLabel-root__Tw5+r`,
	"MuiFormLabel-colorPrimary": `style_MuiFormLabel-colorPrimary__HQncB`,
	"css-1pysi21-MuiFormLabel-root-MuiInputLabel-root": `style_css-1pysi21-MuiFormLabel-root-MuiInputLabel-root__HDXtx`,
	"select_data": `style_select_data__f5l3K`,
	"label_data": `style_label_data__6+Ka9`
};
export default ___CSS_LOADER_EXPORT___;
